import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// components
import CommonModal from "../../../components/modal/CommonModal";
import { authSMS, checkAuthSMS, postAuthPwdChangePhoneNumber } from "../../../services/apis/auth";
import { getUserInfoFromMomthera } from "../../../services/apis/momthera/user";


function MomtheraMyPageModifyPhone() {
    const navigate = useNavigate();

    const [showChangeInfoModal, setShowChangeInfoModal] = useState(false);

    const [phoneNum, setPhoneNum] = useState({ first: "010", middle: "", last: ""});
    const [authNum, setAuthNum] = useState("");

    // none: 미전송, send: 전송, fail: 전송실패
    const [sendAuthState, setSendAuthState] = useState("none");
    // none: 인증번호 미입력, success: 인증번호 일치, fail: 인증번호 불일치
    const [isValidAuth, setIsValidAuth] = useState("none");

    const getCurrentUserInfo = async () => {
        const resUser = await getUserInfoFromMomthera();
        if(Math.floor(resUser.status/100)===2 && resUser.data) {
            return resUser.data;
        }

        throw new Error("사용자 정보 조회 실패");
    }


    const handleSendAuthSMS = async () => {
        if(!(phoneNum.first && phoneNum.middle && phoneNum.last)) {
            return;
        }

        try {
            const currentUserInfo = await getCurrentUserInfo();
            const displayName = currentUserInfo.name || currentUserInfo.displayName || "";

            if(!displayName.trim()) {
                throw new Error("사용자 이름 없음");
            }

            const request = {
                displayName: displayName.trim(),
                phoneNumber: phoneNum.first + phoneNum.middle + phoneNum.last
            }
            const res = await authSMS(request);
            if (parseInt(res.status/200, 10)===1 && res.data.message==="OK") {
                setSendAuthState("send");
            }else{
                setSendAuthState("fail");
            }
        }catch(err) {
            setSendAuthState("fail");
        }
    }

    const handleCheckAuth = async () => {
        if(!authNum) {
            alert("인증번호를 입력하세요.");
            return;
        }

        try {
            const res = await checkAuthSMS({phoneNumber: phoneNum.first+phoneNum.middle+phoneNum.last, authNumber: authNum.trim()});
            if(parseInt(res.status/200, 10)===1 && res.data.message==="OK") {
                setIsValidAuth("success");
            }else{
                setIsValidAuth("fail");
            }
        }catch(err) {
            setIsValidAuth("fail");
        }
    }

    const handleSubmit = async () => {
        try {
            const currentUserInfo = await getCurrentUserInfo();
            if(currentUserInfo.phoneNumber) {
                const oldPhoneNumber = currentUserInfo.phoneNumber;
                try {
                    const userInfo = JSON.parse(localStorage.getItem('dtx006token'));
                    const request = {
                        username: userInfo.email,
                        oldPhoneNumber,
                        newPhoneNumber: phoneNum.first + phoneNum.middle + phoneNum.last,
                        authNumber: authNum
                    }
                    const res = await postAuthPwdChangePhoneNumber(request);
                    if(Math.floor(res.status/100)===2){
                        setShowChangeInfoModal(true);
                    }else{
                        throw new Error();
                    }            
                }catch(err){
                    alert("휴대폰번호 변경 실패");
                }
            }else {
                throw new Error();
            }
        }catch{
            localStorage.removeItem(`dtx006token`);
		    navigate(`/sign-in/dtx006`);
        }
    }

    const closeChangeInfoModal = () => {
        setShowChangeInfoModal(false);
        navigate('/dtx006/mypage');
    }

    const ModifyChangeInfoBody = (
        <div className="mypage_modal_body">회원정보가 수정되었습니다.</div>
    )

    const ModifyChangeInfoFooter = (
        <div className="mypage_modal_footer">
            <button className="submit complete" type="button" onClick={closeChangeInfoModal}>확인</button>
        </div>
    )

    return (
        <div className="dashboardContent dtx006">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">마이페이지</span>
			</div>
            <div className="mypage_center_box_wrapper momthera__mypage__modifyPhone" style={{padding: '3.125rem 0 0',}}>
                <div className="title_wrapper">
                    <div className="title">휴대폰번호 변경</div>
                    <div className="description">
                        휴대폰 번호를 인증하여 휴대폰번호를 변경할 수 있습니다.
                    </div>
                </div>
                <div className="signinLayout__wrapper" style={{backgroundColor: 'transparent', padding: '4.375rem 2.5rem'}}>
                    <div className="signinLayout__wrapper__body">
                        <div
                            className="signinLayout__wrapper__body__option"
                            style={{ marginBottom: '2rem' }}
                        >
                            <span className="optionItem__label">휴대폰번호</span>
                            <div className="optionItem__content" style={{ gap: '1rem' }}>
                                <div
                                    className='optionItem__content__input'
                                    style={{ justifyContent: 'space-between' }}
                                >
                                     <select
                                        className="optionItem__content__input__phone"
                                        value={phoneNum.first}
                                        onChange={e => {
                                            setSendAuthState("none");
                                            setAuthNum("");
                                            setIsValidAuth("none");
                                            setPhoneNum({...phoneNum, first: e.target.value});
                                        }}
                                    >
                                        <option value="010">010</option>
                                        <option value="011">011</option>
                                        <option value="016">016</option>
                                        <option value="017">017</option>
                                        <option value="018">018</option>
                                        <option value="019">019</option>
                                    </select>
                                    <div className="optionItem__content__input__phone__divider">ㅡ</div>
                                    <input
                                        type="text"
                                        className="optionItem__content__input__phone"
                                        value={phoneNum.middle}
                                        onChange={e => {
                                            if (/^\d*$/.test(e.target.value)) { // 숫자만 허용
                                                setSendAuthState("none"); 
                                                setAuthNum("");    
                                                setIsValidAuth("none");                                   
                                                setPhoneNum({...phoneNum, middle: e.target.value});
                                            }                                            
                                        }}
                                        maxLength={4}
                                    />
                                    <div className="optionItem__content__input__phone__divider">ㅡ</div>
                                    <input
                                        type="text"
                                        className="optionItem__content__input__phone"
                                        value={phoneNum.last}
                                        onChange={e => {
                                            if (/^\d*$/.test(e.target.value)) { // 숫자만 허용
                                                setSendAuthState("none");
                                                setAuthNum("");
                                                setIsValidAuth("none");
                                                setPhoneNum({...phoneNum, last: e.target.value});
                                            }
                                        }}
                                        maxLength={4}
                                    />
                                    {sendAuthState==="send" && <p className="optionItem__content__input__validation valid">인증번호를 전송했습니다.</p>}
                                    {sendAuthState==="fail" && <p className="optionItem__content__input__validation non_valid">존재하지 않는 계정입니다.</p>}
                                </div>
                                <button
                                    className="optionItem__content__input__button"
                                    onClick={handleSendAuthSMS}
                                    disabled={!(phoneNum.first && phoneNum.middle && phoneNum.last)}
                                >
                                    인증번호 전송
                                </button>
                            </div>
                        </div>
                        <div
                            className="signinLayout__wrapper__body__option"
                        >
                            <span className="optionItem__label">휴대폰번호 인증</span>
                            <div className="optionItem__content" style={{ gap: '1rem' }}>
                                <div
                                    className={`optionItem__content__input ${sendAuthState==="send" && isValidAuth==="fail" ? "non_valid_input" : ""}`}
                                >
                                    <input
                                        type="text"
                                        value={authNum}
                                        onChange={e => {
                                            setIsValidAuth("none");
                                            setAuthNum(e.target.value);
                                        }}
                                        disabled={sendAuthState!=="send"}
                                        placeholder='인증번호를 입력해주세요.'
                                    />          
                                    {sendAuthState==="send" && isValidAuth==="success" && <p className="optionItem__content__input__validation valid">인증번호가 일치합니다.</p>}                      
                                    {sendAuthState==="send" && isValidAuth==="fail" && <p className="optionItem__content__input__validation non_valid">인증번호가 일치하지 않습니다.</p>}
                                </div>
                                <button
                                    className="optionItem__content__input__button"
                                    onClick={handleCheckAuth}
                                    disabled={!authNum}
                                >
                                    인증하기
                                </button>
                            </div>
                        </div>
                    </div>
                </div>                
                <div className="signinLayout__wrapper__body__footer multiple">
                    <button
                        className="submitButton"
                        onClick={handleSubmit}
                        disabled={isValidAuth!=='success'}
                    >
                        저장
                    </button>
                    <button
                        className="cancelButton"
                        onClick={()=>navigate("/dtx006/mypage")}
                    >
                        취소
                    </button>
                </div>
                <CommonModal
                    header="회원정보 수정"
                    body={ModifyChangeInfoBody}
                    footer={ModifyChangeInfoFooter}
                    show={showChangeInfoModal}
                    setClose={closeChangeInfoModal}
                    size="sm"
                />
            </div>
        </div>
    );
}

export default MomtheraMyPageModifyPhone;
